export default __webpack_public_path__ + "static/media/low_score_icon.65a2da13.svg";